import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Loading screen component displayed during page transitions or data loading
 * @returns {JSX.Element} The LoadingScreen component
 */
const LoadingScreen = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%",
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {t("common.loading")}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
